import { umbracoApi } from "~/utils/axios.util";

export interface LeadCaptureRequestModel {
    email: string;
    firstname: string;
    newsletter?: boolean;
    birthdate?: Date;
    gender?: string;
    clubName?: string
}

class LeadCaptureRepository {
    async subscribe(request: LeadCaptureRequestModel) {
        const response = await umbracoApi.post('/LeadCapture/subscribe', request, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })

        return response.data
    };
}

export default new LeadCaptureRepository();
